import type { Trigger } from "../../generated/WorkflowsApi.types";
import { hasTruthyValues } from "./hasTruthyValues";

export const getTriggerHasValue = (trigger?: Trigger) => {
  if (!trigger) return false;

  // Intentionally exclude community_segment_id from value check
  // as we don't want to force a value for this field to consider trigger to be a valid trigger
  const rest = Object.fromEntries(
    Object.entries(trigger).filter(([key]) => key !== "community_segment_id"),
  );

  return hasTruthyValues(rest);
};
